GameView    = require "views/base/game"
{ DraggyView }    = require("views/components/draggy")
convert   = require("lib/convert")

class ConstructSentenceView extends GameView
  template: require("./template")
  fitTextOnRender: false
  fitTextOnResize: false

  events:
    "iostap .btn-done": "endGame"

  initialize: -> 
    super

    @orderedDraggy ?= []

  serialize: ->
    data = super()

    { title, decoys } = data

    title = convert.toText title
    @words = title.trim().split(" ")
    decoys ?= []

    data.words = ({ word, index } for word, index in @words)
    data.words = data.words.concat ({ word, index: -1 } for word in decoys)...
    data.words = _.shuffle(data.words)

    data

  beforeShow: ->
    @sizeDroppyContainer()

  show: ->
    super()

    @el.classList.remove("active")

    @fitText =>
      draggyEl = @findOne ".draggy-container"

      @draggies =
        for el, i in @findAll(".draggy")
          draggy = new DraggyView
            el: el

          @listenTo draggy, "drag", @onDrag
          @listenTo draggy, "drop", @onDrop
          draggy

      @resetDraggies()
      @listenTo this, "resize", @onResize
      
      @enterGame()
      window.setTimeout (=> @el.classList.add("active")), 300

  onRefresh: ->
    @beforeShow()
    super()

  onDrag: (draggy, isInitialDrag) ->
    if isInitialDrag
      @droppy.bounds = @droppy.el.getBoundingClientRect()

      draggy.el.className = draggy.el.className.replace(/delay-\d/, "")
      child = draggy.el.firstChild
      @droppy.placeholder.style.width  = child.offsetWidth + "px"
      @droppy.placeholder.style.height = child.offsetHeight + "px"

    if isWithin = draggy.isWithin @droppy.bounds, 60
      draggy.isPositioned = true
      @droppy.el.classList.add "active"
      @droppy.placeholder.classList.add("active")
    else
      draggy.isPositioned = false
      @droppy.el.classList.remove "active"
      @droppy.placeholder.classList.remove("active")

    # @rearrangeDraggies(@draggiesInOrder(), draggy)

    @transform draggy.el,
      x: draggy.x
      y: draggy.y
      transition: if isInitialDrag then "all 300ms" else "none"

  onDrop: (draggy, isReset) ->
    unless isReset
      @droppy.placeholder.classList.remove("active")
      @setState "touched"

      if draggy.isPositioned
        @orderedDraggy = @draggiesInOrder()
        @rearrangeDraggies(@orderedDraggy)
      else
        draggy.reset x: 0, y: 0

    @transform draggy.el,
      x: draggy.x
      y: draggy.y
      transition: "all 300ms"

  rearrangeDraggies: (order, activeDraggy) ->
    width   = @droppy.bounds.width
    offsetX = 0
    offsetY = 0

    for draggy, i in order
      x = -draggy.offset.left + offsetX + @droppy.bounds.left
      y = -draggy.offset.top  + offsetY + @droppy.bounds.top

      if @options.config().direction is "rtl"
        x = -draggy.offset.right - offsetX + @droppy.bounds.right

      if (draggy.x isnt x or draggy.y isnt y) and draggy isnt activeDraggy
        draggy.setPosition({ x, y })
        @transform draggy.el, {
          x: x
          y: y
        }

      if draggy is activeDraggy
        x = offsetX
        y = offsetY
        if @options.config().direction is "rtl"
          x = width - x - @droppy.placeholder.offsetWidth
        @transform @droppy.placeholder, { x, y }

      offsetX += draggy.offset.width
      
      if offsetX >= width - (order[i + 1]?.offset.width or 0)
        offsetX = 0
        offsetY += draggy.offset.height

  draggiesInOrder: ->
    { width, height, top } = @droppy.bounds

    _.chain(@draggies)
      .where(isPositioned: true)
      .groupBy (d) ->
        Math.floor(Math.max(d.y + d.offset.top, top) / d.offset.height)

      .map (group, key) =>
        group.sort (a, b) =>
          d = if @options.config().direction is "rtl" then -1 else 1
          (a.offset.left + (a.x + a.offset.width / 2)) * d -
          (b.offset.left + (b.x + b.offset.width / 2)) * d

      .flatten()
      .value()

  showAnswer: ->
    decoys = _.filter @draggies, (d) -> +d?.el.dataset.index < 0
    clone  = _.clone @words

    # Make it so that the abritrary order of duplicates doesn't result in the
    # correct answer being rearranged...
    kindOrder = _.chain(@draggiesInOrder())
      .union(@draggies)
      .without(decoys...)
      .uniq()
      .map (d, i) ->
        index = clone.indexOf(d.el.dataset.word)
        clone[index] = undefined
        { draggy: d, index }
      .sortBy("index")
      .pluck("draggy")
      .value()

    @rearrangeDraggies kindOrder
    d.reset(x: 0, y: 0) for d in decoys

  onResize: ->
    window.setTimeout =>
      @sizeDroppyContainer()
      @resetDraggies()
    , 300

  sizeDroppyContainer: ->
    draggyEl = @findOne ".draggy-container"
    droppyEl = @findOne ".droppy-container"

    # hidden slide have height 0 so use slide-scroller (parent)
    droppyEl.style.height = "#{@el.parentElement.offsetHeight / 2}px"

    @droppy =
      el: droppyEl
      placeholder: @findOne ".droppy-placeholder"

  resetDraggies: ->
    if @draggies and @droppy
      @droppy.bounds = @droppy.el.getBoundingClientRect()
      d.getOffset() for d in @draggies
      # use the existing order instead of re-calculating the order draggies again
      @rearrangeDraggies(@orderedDraggy)

  isCorrect: ->
    correct   = _.filter @draggies, (d) -> +d?.el.dataset.index >= 0
    inOrder   = @draggiesInOrder()
    isCorrect = false # assume it's not correct initially

    # the correct answer length shd match with the selected word length
    # if it doesn't, we'll just return the previously assigned false value in isCorrect
    if inOrder.length is correct.length
      # if it doees, we'll attempt to check the values, which can yield either true or false
      isCorrect = @words.every (word, i) => word is inOrder[i].el.dataset.word

    isCorrect

  answerDetails: ->

    questions = @options.metadata.questions or []
    return [] unless questions.length > 0

    wordsInOrder = _.map @draggiesInOrder(), (draggy) -> draggy.$el.text()
    isCorrect = @isCorrect()
    answer = _.find questions[0].answers, (a) -> a.correct is isCorrect
    answer.content = wordsInOrder.join(" ")
    details = question: questions[0].question, answer: answer

    [details]

  endGame: ->
    super()

    @submit()

module.exports = ConstructSentenceView
